import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState, } from "react";
const AuthContext = createContext(null);
export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) {
        throw new Error("useAuth() must be used within <AuthProvider>");
    }
    return ctx;
}
export function AuthProvider({ fetchUser, onLogout, pollIntervalMs = 5 * 60 * 1000, children, }) {
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const refreshUser = useCallback(async () => {
        try {
            const fresh = await fetchUser();
            setUser(fresh);
        }
        catch {
            setUser(null);
        }
    }, [fetchUser]);
    useEffect(() => {
        void refreshUser().finally(() => setIsLoading(false));
    }, [refreshUser]);
    useEffect(() => {
        if (!pollIntervalMs)
            return;
        const id = setInterval(() => {
            void refreshUser();
        }, pollIntervalMs);
        return () => clearInterval(id);
    }, [pollIntervalMs, refreshUser]);
    const logout = useCallback(() => {
        void onLogout?.();
    }, [onLogout]);
    const value = useMemo(() => ({
        user,
        isAuthenticated: !!user,
        isLoading,
        refreshUser,
        logout,
    }), [user, isLoading, refreshUser, logout]);
    return _jsx(AuthContext.Provider, { value: value, children: children });
}
//# sourceMappingURL=auth-context.js.map